import { render } from "./DayPicker.vue?vue&type=template&id=6d75246c"
import script from "./DayPicker.vue?vue&type=script&lang=ts"
export * from "./DayPicker.vue?vue&type=script&lang=ts"
script.render = render

export default script